import { CurrencyIcon } from '@/components/ui/CurrencyIcon';

interface NetworkIconProps {
  network: string;
  className?: string;
}

// Map Bridge network names to cryptocurrency-icons symbols
// Custom icons added for: ARB, OP, BASE (in /public/crypto-icons/color/)
const NETWORK_SYMBOL_MAP: Record<string, string> = {
  'ethereum': 'ETH',
  'bitcoin': 'BTC',
  'polygon': 'MATIC',
  'solana': 'SOL',
  'avalanche': 'AVAX',
  'optimism': 'OP',      // Custom icon: /public/crypto-icons/color/op.svg
  'arbitrum': 'ARB',     // Custom icon: /public/crypto-icons/color/arb.svg
  'tron': 'TRX',
  'stellar': 'XLM',
  'base': 'BASE',        // Custom icon: /public/crypto-icons/color/base.svg
};

export const NetworkIcon = ({ network, className = "w-4 h-4" }: NetworkIconProps) => {
  // Defensive check: return fallback if network is undefined/null
  if (!network) {
    return (
      <CurrencyIcon
        symbol="ETH"
        className={className}
        size="sm"
      />
    );
  }

  const normalizedNetwork = network.toLowerCase();
  const symbol = NETWORK_SYMBOL_MAP[normalizedNetwork] || normalizedNetwork;

  // Extract size from className if present (rough heuristic) or default to 16px
  // Since CurrencyIcon uses specific sizes, we can try to map or just use 'sm'/'xs'
  // For now, we'll pass the className and let CurrencyIcon handle sizing via style or class

  return (
    <CurrencyIcon
      symbol={symbol}
      className={className}
      size="sm" // Default small size for inline icons
    />
  );
};

interface AssetIconProps {
  asset: string;
  className?: string;
}

export const AssetIcon = ({ asset, className = "w-4 h-4" }: AssetIconProps) => {
  return (
    <CurrencyIcon
      symbol={asset}
      className={className}
      size="sm"
    />
  );
};